import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-aggregated-amount-item',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <mat-card
      matRipple
      [matRippleDisabled]="!hasLink()"
      (click)="onCardClick()"
      [class.has-link]="hasLink()"
      >
      <mat-card-content>
      <div fxLayout="row wrap" fxLayoutGap="8px" fxLayoutAlign="start center">
        <img class="icon" [src]="icon" />
        <div
          fxLayout="row wrap"
          fxLayoutAlign=" center"
          class="name"
          fxFlex="1 1 70%"
          fxFlex.md="60%"
          >
          <div>
            <div>{{ name }}<br />{{ account }}</div>
          </div>
        </div>
        <div fxFlex="1 1 auto"></div>
        @if (help) {
          <mat-icon class="help" [matTooltip]="help">help_outline</mat-icon>
        }
      </div>
      <div class="content">
        <app-data-field legend="{{ unit }}">
          <div fxFlex="1 1 auto">
            <div fxLayout="row wrap" fxLayoutGap="8px" fxLayoutAlign="center baseline">
              @if (!loading) {
                @if (hasAmount) {
                  <div class="amount">{{ amount | number }}</div>
                  <div fxLayout fxLayoutAlign="start center">
                    @if (rate !== null) {
                      @if (isDecimal != null) {
                        <div>{{ rate | number: '1.1-1' }}%</div>
                      }
                      @if (isDecimal == null) {
                        <div>{{ rate | number: '1.0-0' }}%</div>
                      }
                      @if (rate > 100) {
                        <mat-icon>trending_up</mat-icon>
                      }
                      @if (rate < 100) {
                        <mat-icon>trending_down</mat-icon>
                      }
                    } @else {
                      <div>- %</div>
                    }
                  </div>
                } @else {
                  <div class="no-data">−</div>
                }
              } @else {
                <app-music-note></app-music-note>
              }
            </div>
          </div>
          <div fxLayoutAlign="right end">
            @if (!dataCollectLoading) {
              @if (dataCollections) {
                <img
                  class="datafix_icon"
                  matTooltip="各項目において選択した期間のデータが全部揃っている場合に、チェックマークが表示されます。"
                  src="./assets/data_collections.png"
                  />
                } @else {
                  <img class="datanofix_icon" src="./assets/data_collections.png" />
                }
              } @else {
                <img class="datanofix_icon" src="./assets/data_collections.png" />
              }
            </div>
          </app-data-field>
        </div>
        </mat-card-content>
      </mat-card>
    
    
    
    
    
    `,
    styleUrls: ['./aggregated-amount-item.component.scss'],
    standalone: false
})
export class AggregatedAmountItemComponent implements OnInit {
  @Input()
  name: string

  @Input()
  account: string

  @Input()
  icon: string

  @Input()
  amount: number

  @Input()
  unit: string

  @Input()
  rate: number

  @Input()
  link: string

  @Input()
  help: string

  @Input()
  hasAmount = true

  @Input()
  loading = true

  @Input()
  dataCollections = false

  @Input()
  dataCollectLoading = true

  @Input()
  isDecimal: string

  constructor() {}

  ngOnInit() {}

  hasLink(): boolean {
    return this.link != null && this.link !== ''
  }

  onCardClick(): void {
    if (this.hasLink()) {
      window.open(this.link)
    }
  }
}
